import React from 'react';
import {
  Box,
  Typography,
  Button,
  FormControlLabel,
  Checkbox,
  Stack,
  Divider,
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import BodyParameterField from './BodyParameterField';

export default function BodyParametersSection({
  body,
  body_errors,
  positional,
  onParameterChange,
  onAddParameter,
  onRemoveParameter,
  onMoveUp,
  onMoveDown,
  onPositionalChange,
  edit,
}) {
  return (
    <Box>
      <Divider sx={{ my: 2 }} />
      <Typography variant='h6' sx={{ mb: 2 }}>
        Request Body Template
      </Typography>
      <Stack spacing={2}>
        {body.map((param, i) => (
          <BodyParameterField
            key={`param-${i}`}
            index={i}
            value={param}
            error={body_errors[i]}
            onChange={onParameterChange}
            onRemove={onRemoveParameter}
            onMoveUp={onMoveUp}
            onMoveDown={onMoveDown}
            positional={positional}
            isFirst={i === 0}
            isLast={i === body.length - 1}
            edit={edit}
          />
        ))}
        <Button
          variant='outlined'
          startIcon={<AddIcon />}
          onClick={onAddParameter}
          disabled={edit}
          sx={{ alignSelf: 'flex-start' }}
        >
          Add Parameter
        </Button>
        <FormControlLabel
          control={
            <Checkbox
              checked={positional}
              onChange={(e) => onPositionalChange(e.target.checked)}
              disabled={edit}
            />
          }
          label='Function Uses Positional Arguments'
        />
      </Stack>
    </Box>
  );
}

